import WarningIcon from "../../assets/images/warning.svg";
import { useStateContext } from "../../contexts/ContextProvider";

const DeleteLeave = ({ deleteLeave }) => {
  const { deleteLeaveModal, setDeleteLeaveModal } = useStateContext();
  return (
    <>
      <div
        className={`${
          deleteLeaveModal ? "deleteModal visible" : "deleteModal hidden"
        }`}
      >
        <div className="flex">
          <div className="icon">
            <img src={WarningIcon} alt="" />
          </div>
          <div className="content">
            <span className="heading">
              Are you sure you want to delete this leave !
            </span>
            <span className="para">
              Deleting this leave will remove all its details amd also delete it
              from the receiver's dashboard.
            </span>
          </div>
        </div>
        <div className="action">
          <span
            className="cancel"
            onClick={(e) => {
              setDeleteLeaveModal(false);
            }}
          >
            Cancel
          </span>
          <span className="delete" onClick={deleteLeave}>
            Delete
          </span>
        </div>
      </div>
    </>
  );
};

export default DeleteLeave;
